import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { AuthService } from '../auth.service';
import { MatDialog } from '@angular/material';
import { AbstractControl } from '@angular/forms';
import { LoggerService } from 'app/logger/logger.service';
// global const
const PASSWORD_REGEX = /((?=.*\d)(?=.*[A-Za-z])(?=.*[0-9]).{6,18})/;
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  // public variables
  public user_id: string;
  public old_password: string;
  public password: string;
  public confirm_password: string;
  public is_password_valid: boolean;
  public confirm_pass_valid: boolean ;
  public form;

  constructor(private fb: FormBuilder, private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService,private logger:LoggerService,
    private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {
     this.form = fb.group({
        passwordFormControl: ['', Validators.compose([Validators.required, Validators.pattern(PASSWORD_REGEX)])],
        confirmPasswordFormControl: ['']
        }, {
        validator: PasswordValidation.MatchPassword
        })
      this.sharedService.setHeaderTitle('default_page');
      let methodName = this.constructor.name+'.verifyToken';
       if (this.localStorageService.get('token') != null) {
        this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));

          // Used for dataLayer.push
          const dataLayerAccountInfo = res.results[0]['personal'];

          var dataLayerEvent = 'change password';
          (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

            if (res.status === 'success' && res.isTerminated === false) {
              const that = this.sharedService;
              setTimeout(function(){
                that.setHeaderErrorMessage('change_password', false, 'notification error', '');
                that.setHeaderSuccessMessage('change_password', false, '');
                that.setHeaderTitle('change_password');
                setTimeout(function(){const len = document.getElementsByTagName('body')[0];
                len.click(); }, 10);
              }, 10);
              this.confirm_pass_valid = false;
          }else {
              this.localStorageService.remove('token');
              this.localStorageService.remove('tempToken');
              this.router.navigate(['./sign-in']);
            }
          }, (error)=>{
            let logObj = {
              method: methodName,
              request: "token : [masked]",
              exception: error
            };
            this.logger.logError(JSON.stringify(logObj));
          }).catch((ex)=>{
            let logObj = {
              method: methodName,
              request: "token : [masked]",
              exception: ex
            };
            this.logger.logError(JSON.stringify(logObj));
          });
      }else {
          this.router.navigate(['./sign-in']);
      }
   }

  // form validations
  // tslint:disable-next-line:member-ordering
  passwordValidate = new FormControl('', [Validators.required, Validators.pattern(PASSWORD_REGEX)]);
  // tslint:disable-next-line:member-ordering
  oldPasswordValidate = new FormControl('', [
    Validators.required,
    Validators.pattern(PASSWORD_REGEX)]);
  // tslint:disable-next-line:member-ordering
  confirmPasswordValidate = new FormControl('', [Validators.pattern(PASSWORD_REGEX)]);

  ngOnInit() {
  }

  changePasswordValidate(event: any) {
    if (this.password !== '' && this.confirm_password !== '' && this.password !== undefined &&
    this.confirm_password !== undefined &&  this.password.length > 5 &&
    this.confirm_password.length > 5 && this.password.match(PASSWORD_REGEX) && (this.password === this.confirm_password)) {
      this.is_password_valid = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    }else {
      this.is_password_valid = false;
    }
  }

  confirmPasswordMatch(event: any) {
   if (this.password !== '' && event.keyCode !== 13) {
      this.confirm_password = '';
      this.is_password_valid = false;
      }
  }

  // password change
  changePassword() {
    this.sharedService.setHeaderErrorMessage('change_password', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('change_password', false, '');
    let methodName = this.constructor.name+'.changePassword';
    if (this.password !== this.old_password) {
      this.authService.changePassword({'token': this.localStorageService.get('token'),
       'password': this.password, 'oldPassword': this.old_password})
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked]",
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
          if (res.status === 'success') {

            this.dialog.open(SuccessAlert);

          }else {
            if (res.type === 'timeup') {
              this.dialog.open(InfoTimeup);
            }else {
              window.scrollTo(0, 0);
              this.sharedService.setHeaderErrorMessage('change_password', true, 'notification error', res.message);
            }
          }
        }, (error)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
    }else {
      window.scrollTo(0, 0);
      this.sharedService.setHeaderErrorMessage('change_password', true, 'notification error',
      'New password should not be same as old password');
    }
  }

}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'success-alert',
  template: `<div class="dialog-main">
  <button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button>
  <div class="dialog-info"><h3 class="text-center">Success</h3>
  <p>Your password has been changed!</p></div></div><div class="footer">
  <button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="successOk()">Ok</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class SuccessAlert {
  constructor(private activatedRoute: ActivatedRoute,
    private sharedService: SharedService, private authService: AuthService,
    private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {

  }

  successOk() {
    this.router.navigate(['./Profile/AccountSetting']);
  }
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'info-timeup',
  template: `<div class="dialog-main">
  <button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button>
  <div class="dialog-info"><h3 class="text-center">Info</h3>
  <p>Your request time is 20 minutes over. Please login again to change your password.</p></div></div>
  <div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="infoOk()">Ok</button></div>`,
})

// tslint:disable-next-line:component-class-suffix
export class InfoTimeup {
  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
    private authService: AuthService, private router: Router, private localStorageService: LocalStorageService, private dialog: MatDialog) {

  }

  infoOk() {
    this.router.navigate(['./Profile/AccountSetting/SignIn']);
  }
}
export class PasswordValidation {
    static MatchPassword(AC: AbstractControl) {
       const password = AC.get('passwordFormControl').value; // to get value in input tag
       const confirmPassword = AC.get('confirmPasswordFormControl').value; // to get value in input tag
        if (password !== confirmPassword) {
            AC.get('confirmPasswordFormControl').setErrors( {MatchPassword: true} )
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/change-password/change-password.component.ts